import { dispatchCustomEvent } from "../../../../javascript/shared/helpers";
import FileUploadsPendingUploadController from "../../../file_uploads/assets/javascript/file-uploads-pending-upload-controller"

export default class extends FileUploadsPendingUploadController {
  static targets = ["destroy", "progress", "filename", "fileField", "nameField"]

  connect() {
    super.connect()
    this.hidden = this.markedForDestruction;
    App.Helpers.listenToCustomEvent(document, "message--file-exchange", this.setFileFieldFiles.bind(this))
    addEventListener("direct-upload:end", this.markFileUploadAsComplete.bind(this)) // if the progress has started, the first submission should be past
  }

  setFileFieldFiles(event) {
    const { dataTransfer, fileID } = event.detail
    if (fileID === this.uploadID) {
      this.fileFieldTarget.files = dataTransfer.files
      this.name = dataTransfer.files[0].name
      this.dataTransfer = dataTransfer
    }
  }

  onUploadStart(event) {
    const { id, file } = event.detail
    if (file === this.file) {
      this.uploadID = id
      super.onUploadStart(event)
    }
  }

  markFileUploadAsComplete(event) {
    const { id } = event.detail
    if (id == this.uploadID) {
      this.fileUploadComplete = true
    }
  }

  addCompleteClass(event) {
    super.addCompleteClass(event)
    this.element.classList.remove("pending-upload")
    dispatchCustomEvent("message--file-upload-complete", this.element)
  }

  removeNewFile(event) {
    event && event.preventDefault();
    this.emitDirtyFormEvent();
    this.element.remove();
  }

  removeExistingFile(event) {
    event && event.preventDefault();
    this.destroy = true;
    this.emitDirtyFormEvent();
    this.hidden = true;
  }

  emitDirtyFormEvent() {
    dispatchCustomEvent('dirty-form', this.element)
  }

  //
  // GETTERS AND SETTERS
  //

  set destroy(val) {
    this.destroyTarget.value = val ? '1' : '0';
  }

  get file() {
    return this.dataTransfer ? this.dataTransfer.files[0] : null
  }

  set hidden(val) {
    App.Helpers[`${val ? 'hide' : 'show'}Element`](this.element);
  }

  get markedForDestruction() {
    return this.destroyTarget.value === '1';
  }

  set name(text) {
    this.filenameTarget.innerText = text
    this.nameFieldTarget.value = text
  }
}



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/messages-file-attachment-controller.js